import { render, staticRenderFns } from "./pk10.vue?vue&type=template&id=8b56f152&scoped=true"
import script from "./pk10.vue?vue&type=script&lang=js"
export * from "./pk10.vue?vue&type=script&lang=js"
import style0 from "./pk10.vue?vue&type=style&index=0&id=8b56f152&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b56f152",
  null
  
)

export default component.exports